import { format } from "date-fns";

const { createSlice } = require("@reduxjs/toolkit");

function formatDateDisplay(date, defaultText) {
  if (!date) return defaultText;
  return format(date, "yyyy-MM-dd");
}
// FOR SETTING THE CURRENT PERIOD (June 2024 - August 2024)
const current_start_date = new Date('2024-06-01');
const current_end_date = new Date('2024-08-31');

// FOR SETTING THE PREVIOUS PERIOD (March 2024 - May 2024)
const previous_start_date = new Date('2024-03-01');
const previous_end_date = new Date('2024-05-31');


const initialState = {
  startDate: formatDateDisplay(current_start_date),
  endDate: formatDateDisplay(current_end_date),
  prevStartDate: formatDateDisplay(previous_start_date),
  prevEndDate: formatDateDisplay(previous_end_date),
};

const dateSlice = createSlice({
  name: "dates",
  initialState,
  reducers: {
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setPrevStartDate: (state, action) => {
      state.prevStartDate = action.payload;
    },
    setPrevEndDate: (state, action) => {
      state.prevEndDate = action.payload;
    },
    resetDates: () => initialState
  },
});

export const { setStartDate, setEndDate, setPrevStartDate, setPrevEndDate, resetDates } =
  dateSlice.actions;

export default dateSlice.reducer;
